import React from "react";
import SideBar from "../components/ThemeComponent/ThemeSideBar";
import ThemeNavBar from "../components/ThemeComponent/ThemeNavBar";
import { getToken } from "../Redux/services/localStorageService.js";
import { Navigate } from "react-router-dom";

const ProtectedLayout = ({ children }) => {
  const token = getToken();
  return token ? (
    <div className="protected-layout d-flex">
      <SideBar />
      <div className="content">
        <ThemeNavBar />
        <div className="children">{children}</div>
      </div>
    </div>
  ) : (
    <Navigate to={'/'} replace />
  );
};

export default ProtectedLayout;
